import React from 'react';

export const LazyArtistMain = React.lazy(() =>
  import(/* webpackChunkName: "artist" */ './Main'),
);

export const LazyArtistFooter = React.lazy(() =>
  import(
    /* webpackChunkName: "artist" */ '../../features/page/Footer'
  ).then(({ PageFooter }) => ({ default: PageFooter })),
);

export const LazyArtistHeader = React.lazy(() =>
  import(
    /* webpackChunkName: "artist" */ '../../features/ArtistHeader'
  ).then(({ ArtistHeader }) => ({ default: ArtistHeader })),
);
